import Splide from '@splidejs/splide'

export default function Sliders() {
	// --- Banner Slider ---
	const bannerElements = document.querySelector('.js-banner-slider')
	bannerElements && new Splide('.js-banner-slider', {
		type: 'loop',
		arrows: false,
		pagination: true,
		keyboard: false,
		drag: true,
		rewind: true,
		autoplay: true,
		speed: 1000,
		interval: 7000,
		pauseOnHover: false,
		snap: true,
		autoHeight: true,
		classes: {
			pagination: 'splide__pagination o-list-bare e-dots',
			page: 'splide__pagination__page o-list-bare__item e-dots__item',
		},
	}).mount()

	// --- USP Slider ---
	const uspElements = document.querySelector('.js-usp-slider')
	uspElements && new Splide('.js-usp-slider', {
		type: 'slide',
		perPage: 1,
		perMove: 1,
		pagination: false,
		gap: 20,
		arrows: false,
		mediaQuery: 'min',
		breakpoints: {
			767: {
				perPage: 2,
			},
			1023: {
				perPage: 3,
			},
			1439: {
				perPage: 4,
			},
		},
	}).mount()

	// --- Logos Slider ---
	const logosElements = document.querySelector('.js-logo-slider')
	logosElements && new Splide('.js-logo-slider', {
		type: 'loop',
		perPage: 1,
		perMove: 1,
		gap: 20,
		pagination: false,
		arrows: false,
		mediaQuery: 'min',
		autoplay: true,
		speed: 1000,
		interval: 5000,
		breakpoints: {
			450: {
				perPage: 2,
			},
			767: {
				perPage: 3,
				gap: 40,
			},
			1023: {
				perPage: 4,
			},
			1279: {
				perPage: 6,
			},
		},
	}).mount()

	// --- Testimonial slider ---
	const testimonialElements = document.querySelectorAll('.js-testimonial-slider')

	if (testimonialElements.length) {
		testimonialElements.forEach(testinmonials => {
			const testimonialSlider = new Splide(testinmonials, {
				type: 'loop',
				pagination: false,
				arrows: true,
			}).mount()
		})
	}

	// --- Product image sliders ---

	if(document.querySelector('.js-main-product-images') && document.querySelector('.js-product-thumbnails')) {

		const mainProductElements = new Splide('.js-main-product-images', {
			type: 'fade',
			arrows: true,
			pagination: false,
			keyboard: false,
			drag: false,
			autoplay: false,
			snap: true,
			gap: '20px',
			perPage: 1,
		})

		const thumbnailProductElements = new Splide('.js-product-thumbnails', {
			arrows: false,
			pagination: false,
			keyboard: false,
			drag: false,
			autoplay: false,
			isNavigation: true,
			perPage: 4,
		})
		
		mainProductElements.sync( thumbnailProductElements )
		mainProductElements.mount()
		thumbnailProductElements.mount()
	}
}
